import { Icon, Button, FormLayout, TextField, Tooltip, Popover, Autocomplete, Badge, ContextualSaveBar, BlockStack, Grid, Text, ButtonGroup, Divider, InlineStack, Link, ActionList, Modal, InlineGrid, Box, Banner } from '@shopify/polaris';
import React, { useCallback, useEffect, useState } from 'react';
import { SearchMinor, DeleteMinor, PlusMinor, RefreshMajor, CircleTickMinor, CircleAlertMajor, AddMajor, DeleteMajor, CancelMajor, MobileVerticalDotsMajor, EditMajor, InfoMinor } from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../../Core';
import { Switch } from 'antd';
import useContextualSaveBar, { isAdminLoggedIn } from '../../../Panel/index';
import { getLastSyncInformation } from '../../ConfigHelper';
import { RenderSkeletonShipment } from '../../skeleton/skeleton';
import { InfoIcon } from 'src/Asests/svgIcon/icon';
import { useTranslation } from 'react-i18next';

const defaultOrderSettings = {
    "shipping_carrier_map": false,
    "carrier_codes": [{
        "shopify_carrier_code": "",
        "amazon_carrier_code": "",
        "carrier_name": ""
    }],
    "order_sync": true,
    "shipment": true,
    "tracking_number": false,
    "tracking_company": false,
}

const defaultErrors = {
    carrierCodes: [],
};
interface ShipmentProps extends DIProps {
    setOrderSettingsEnabled: (e: boolean) => void;
    saveLoader: boolean;
    setSaveLoader: (e: boolean) => void;
    getLoader: boolean;
    setGetLoader: (e: boolean) => void;
    showSkeleton: boolean;
    setShowSkeleton: (e: boolean) => void
}

function Shipment(props: ShipmentProps) {
    const { t } = useTranslation();
    const { showSaveBar, hideSaveBar } = useContextualSaveBar(props);
    const { showSkeleton, setShowSkeleton, saveLoader, setSaveLoader, getLoader, setGetLoader } = props;
    const [originalData, setOriginalData] = useState<any>(JSON.parse(JSON.stringify(defaultOrderSettings)));
    const [errors, setErrors] = useState<any>(JSON.parse(JSON.stringify(defaultErrors)));
    const [showContextualSaveBar, setShowContextualSaveBar] = useState<boolean>(false);
    const [preparedData, setPreparedData] = useState<any>(JSON.parse(JSON.stringify(defaultOrderSettings)));
    const [ignoreShopifyCarrierCodes, setignoreShopifyCarrierCodes] = useState<string[]>([]);

    const handleSettingsEnableOrDisable = (e: boolean) => {
        handleData("shipment", "", e)
        if (!e) removeErrors('carrierCodes')
    }

    const handleData = (key: string, subkey: string, value: any) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        if (subkey != "") {
            tempPreparedData[key][subkey] = value
        }
        else {
            tempPreparedData[key] = value
        }
        setPreparedData({ ...tempPreparedData });
    }

    const deselectedShopifyCarrierCodes = [
        { value: 'Add custom', label: t('Add custom') },
        { value: 'Shopify Carrier code 1', label: t('Shopify Carrier code 1') },
        { value: 'Shopify Carrier code 2', label: t('Shopify Carrier code 2') },
        { value: 'Shopify Carrier code 3', label: t('Shopify Carrier code 3') },
        { value: 'Shopify Carrier code 4', label: t('Shopify Carrier code 4') },
    ];
    const deselectedAmazonCarrierCodes = [
        { value: 'Add custom', label: t('Add custom') },
        { value: 'Amazon Carrier code 1', label: t('Amazon Carrier code 1') },
        { value: 'Amazon Carrier code 2', label: t('Amazon Carrier code 2') },
        { value: 'Amazon Carrier code 3', label: t('Amazon Carrier code 3') },
        { value: 'Amazon Carrier code 4', label: t('Amazon Carrier code 4') },
    ];
    const [amazonCarrierCodes, setAmazonCarrierCodes] = useState(deselectedAmazonCarrierCodes);
    const [amazonCarrierCodesFromBackend, setAmazonCarrierCodesFromBackend] = useState(deselectedAmazonCarrierCodes);
    const [shopifyCarrierCodes, setShopifyCarrierCodes] = useState(deselectedShopifyCarrierCodes);
    const [shopifyCarrierCodesFromBackend, setShopifyCarrierCodesFromBackend] = useState(deselectedShopifyCarrierCodes);
    const [loading, setLoading] = useState(false);
    const [uiCarrierCode, setUiCarrierCode] = useState<any>([]);
    const [lastSync, setLastSync] = useState('')

    const getLastOrderSyncDate = () => {
        let data = getLastSyncInformation(props, 'order');
        data.then((res: any) => {
            if (res?.error) props.error(t(res?.error) ?? '');
            else setLastSync(res?.date ?? '')
        })
    }
    const removeStaleValues = (obj: any) => {
        let updatedData: any = JSON.parse(JSON.stringify(obj));
        if (!updatedData.order_sync) {
            updatedData = JSON.parse(JSON.stringify({ ...defaultOrderSettings, ...obj }));
            updatedData['order_sync'] = !updatedData.hasOwnProperty('order_sync') ? true : updatedData?.order_sync;
        }
        else {
            if (!updatedData.shipment) {
                updatedData = {
                    ...updatedData,
                    shipment: !updatedData.hasOwnProperty('shipment') ? true : updatedData.shipment,
                    tracking_number: JSON.parse(JSON.stringify(obj?.tracking_number || defaultOrderSettings.tracking_number)),
                    tracking_company: JSON.parse(JSON.stringify(obj?.tracking_company || defaultOrderSettings.tracking_company)),
                    shipping_carrier_map: JSON.parse(JSON.stringify(obj?.shipping_carrier_map || defaultOrderSettings.shipping_carrier_map)),
                    carrier_codes: JSON.parse(JSON.stringify(obj?.carrier_codes || defaultOrderSettings.carrier_codes))
                }
            } else {
                if (!updatedData.shipping_carrier_map)
                    updatedData = {
                        ...updatedData,
                        shipment: !updatedData.hasOwnProperty('shipment') ? true : updatedData.shipment,
                        carrier_codes: JSON.parse(JSON.stringify(obj?.carrier_codes || defaultOrderSettings?.carrier_codes))
                    }
            }
        }
        return updatedData;
    }

    const getOrderSettings = () => {
        setSaveLoader(true)
        props.di.POST('connector/config/getConfig', {
            "group_code": ["order"]
        }).then((response: any) => {
            setSaveLoader(false)
            setShowSkeleton(false);
            if (response?.success) {
                if (response?.data?.[0]?.group_code == "order" && response?.data?.[0]?.value && Object.keys(response?.data?.[0]?.value).length > 0) {
                    let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
                    let myCarrierCodes: any = [];
                    let receivedData: any = removeStaleValues(JSON.parse(JSON.stringify(response?.data?.[0]?.value)));

                    let tempErrors = JSON.parse(JSON.stringify(defaultErrors));
                    let tempIgnoreShopifyCarrierCodes: any = [];
                    receivedData?.carrier_codes?.map((obj: any, index: number) => {
                        tempIgnoreShopifyCarrierCodes.push(obj?.shopify_carrier_code);
                        tempErrors.carrierCodes.push({ shopify: false, amazon: false })
                        myCarrierCodes.push({ ...obj, activateShopify: false, activateAmazon: false, isShopifyDisabled: true, isAmazonDisabled: true })
                    });
                    setignoreShopifyCarrierCodes([...tempIgnoreShopifyCarrierCodes]);

                    if (myCarrierCodes.length == 0) {
                        tempErrors.carrierCodes.push({ shopify: false, amazon: false })
                        setUiCarrierCode([{ "shopify_carrier_code": "", "amazon_carrier_code": "", activateShopify: false, activateAmazon: false, isShopifyDisabled: true, isAmazonDisabled: true }])
                    }
                    else setUiCarrierCode([...myCarrierCodes]);

                    if (receivedData.hasOwnProperty('carrier_codes')) {
                        tempPreparedData['carrier_codes'] = receivedData['carrier_codes'];
                    }
                    // if (receivedData.hasOwnProperty('carrier_names')) {
                    //     tempPreparedData['carrier_names'] = receivedData['carrier_codes'];
                    // }
                    if (receivedData.hasOwnProperty('order_sync')) {
                        tempPreparedData['order_sync'] = receivedData['order_sync'];
                    }
                    if (receivedData.hasOwnProperty('shipment')) {
                        tempPreparedData['shipment'] = receivedData['shipment'];
                    }
                    if (receivedData.hasOwnProperty('tracking_number')) {
                        tempPreparedData['tracking_number'] = receivedData['tracking_number'];
                    }
                    if (receivedData.hasOwnProperty('tracking_company')) {
                        tempPreparedData['tracking_company'] = receivedData['tracking_company'];
                    }
                    if (receivedData.hasOwnProperty('shipping_carrier_map')) {
                        tempPreparedData['shipping_carrier_map'] = receivedData['shipping_carrier_map'];
                    }
                    setErrors(JSON.parse(JSON.stringify(tempErrors)));
                    setOriginalData(JSON.parse(JSON.stringify(tempPreparedData)));
                    setPreparedData(JSON.parse(JSON.stringify(tempPreparedData)));
                    props.setOrderSettingsEnabled(receivedData.order_sync)
                }
            }
            else { //front end se api call mein agar koi error hogi
                props.error(t("Oops! Some error occured while getting order settings."));
            }
        });
    }

    function getAndSetShopifyCarrierCodes() {
        props.di.GET("connector/order/getShippingCarriers", { "target": "shopify" }).then((response: any) => {
            if (response?.status) {
                const options = response?.message.map((elem: string) => {
                    return { label: elem, value: elem }
                })
                setShopifyCarrierCodes([{ value: 'Add custom', label: t('Add custom') }, ...options])
                setShopifyCarrierCodesFromBackend([{ value: 'Add custom', label: t('Add custom') }, ...options])
            }
        })
    }

    function getAndSetAmazonCarrierCodes() {
        props.di.GET("connector/order/getShippingCarriers", { "target": "amazon" }).then((response: any) => {
            if (response?.status) {
                const options = response?.message.map((elem: string) => {
                    return { label: elem, value: elem }
                })
                setAmazonCarrierCodes([{ value: 'Add custom', label: t('Add custom') }, ...options])
                setAmazonCarrierCodesFromBackend([{ value: 'Add custom', label: t('Add custom') }, ...options])
            }
        })
    }

    useEffect(() => {
        setShowSkeleton(true);
        getOrderSettings();
        getLastOrderSyncDate();
        getAndSetShopifyCarrierCodes();
        getAndSetAmazonCarrierCodes();
    }, []);

    useEffect(() => {
        if (Object.keys(preparedData).length > 0) {
            if (JSON.stringify(originalData) != JSON.stringify(removeStaleValues(preparedData))) setShowContextualSaveBar(true);
            else setShowContextualSaveBar(false);
        }
    }, [preparedData])

    const updateSelection = (type: string, selected: any, index: number) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        let tempErrors = JSON.parse(JSON.stringify(errors));

        if (selected[0] == "Add custom") {
            if (type == "shopify") {
                tempPreparedData['carrier_codes'][index]['shopify_carrier_code'] = '';
                uiCarrierCode[index]['shopify_carrier_code'] = '';
                uiCarrierCode[index]['isShopifyDisabled'] = false
                uiCarrierCode[index]['activateShopify'] = false
                tempErrors['carrierCodes'][index]['shopify'] = selected[0] == "";
                if (typeof ignoreShopifyCarrierCodes[index] !== 'undefined') {
                    ignoreShopifyCarrierCodes.splice(index, 1);
                    setignoreShopifyCarrierCodes([...ignoreShopifyCarrierCodes])
                }
            }
            else {
                tempPreparedData['carrier_codes'][index]['amazon_carrier_code'] = 'Other';
                tempPreparedData['carrier_codes'][index]['carrier_name'] = '';
                // tempPreparedData['carrier_name'] = {
                //     ...tempPreparedData['carrier_name'],
                //     [index]: {
                //         'amazon_carrier_name': '',
                //         'shopify_carrier_name': tempPreparedData?.['carrier_codes']?.[index]?.['shopify_carrier_code'] || ""
                //     }

                // }
                // tempErrors['carrier_name'] = {
                //     ...tempErrors['carrier_name'],
                //     [index]: { 'amazon': false }
                // }
                uiCarrierCode[index]['amazon_carrier_code'] = '';
                uiCarrierCode[index]['isAmazonDisabled'] = false
                uiCarrierCode[index]['activateAmazon'] = false
                tempErrors['carrierCodes'][index]['amazon'] = selected[0] == ""
            }
        }
        else if (selected[0] == "Other") {
            if (type == "shopify") {
                tempPreparedData['carrier_codes'][index]['shopify_carrier_code'] = selected?.[0];
                uiCarrierCode[index]['shopify_carrier_code'] = '';
                uiCarrierCode[index]['isShopifyDisabled'] = true
                uiCarrierCode[index]['activateShopify'] = false
                tempErrors.carrierCodes[index]['shopify'] = selected?.[0] == '';
                let tempIgnoreShopifyCarrierCodes = tempPreparedData.carrier_codes.map((code: any) => {
                    return code.shopify_carrier_code;
                })
                setignoreShopifyCarrierCodes([...tempIgnoreShopifyCarrierCodes]);
            }
            else {
                tempPreparedData['carrier_codes'][index]['amazon_carrier_code'] = 'Other';
                tempPreparedData['carrier_codes'][index]['carrier_name'] = '';
                // tempPreparedData['carrier_name'] = {
                //     ...tempPreparedData['carrier_name'],
                //     [index]: {
                //         'amazon_carrier_name': '',
                //         'shopify_carrier_name': tempPreparedData?.['carrier_codes']?.[index]?.['shopify_carrier_code'] || ""
                //     }

                // }
                // tempErrors['carrier_name'] = {
                //     ...tempErrors['carrier_name'],
                //     [index]: { 'amazon': false }
                // }
                uiCarrierCode[index]['amazon_carrier_code'] = '';
                uiCarrierCode[index]['isAmazonDisabled'] = false
                uiCarrierCode[index]['activateAmazon'] = false
                tempErrors['carrierCodes'][index]['carrier_name'] = selected[0] == ""
            }

        }
        else {
            if (type == "shopify") {
                tempPreparedData['carrier_codes'][index]['shopify_carrier_code'] = selected?.[0];
                uiCarrierCode[index]['shopify_carrier_code'] = '';
                uiCarrierCode[index]['isShopifyDisabled'] = true
                uiCarrierCode[index]['activateShopify'] = false
                tempErrors.carrierCodes[index]['shopify'] = selected?.[0] == '';
                let tempIgnoreShopifyCarrierCodes = tempPreparedData.carrier_codes.map((code: any) => {
                    return code.shopify_carrier_code;
                })
                setignoreShopifyCarrierCodes([...tempIgnoreShopifyCarrierCodes]);
            }
            else {
                tempPreparedData['carrier_codes'][index]['amazon_carrier_code'] = selected?.[0];
                if (tempPreparedData.carrier_codes[index].hasOwnProperty('carrier_name')) {
                    delete tempPreparedData.carrier_codes[index]['carrier_name'];
                }
                uiCarrierCode[index]['amazon_carrier_code'] = '';
                uiCarrierCode[index]['isAmazonDisabled'] = true
                uiCarrierCode[index]['activateAmazon'] = false
                tempErrors.carrierCodes[index]['amazon'] = selected?.[0] == ''
            }
        }
        setUiCarrierCode(JSON.parse(JSON.stringify([...uiCarrierCode])))
        setPreparedData({ ...tempPreparedData })
        setErrors(JSON.parse(JSON.stringify(tempErrors)))
    }

    const addCarrierCodeRow = () => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
        tempPreparedData.carrier_codes.push({ "shopify_carrier_code": "", "amazon_carrier_code": "" });
        setPreparedData({ ...tempPreparedData })

        uiCarrierCode.push({ "shopify_carrier_code": "", "amazon_carrier_code": "", activateShopify: false, activateAmazon: false, isShopifyDisabled: true, isAmazonDisabled: true });
        setUiCarrierCode([...uiCarrierCode]);

        let tempErrors = JSON.parse(JSON.stringify(errors));
        tempErrors.carrierCodes.push({ shopify: false, amazon: false })
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
    }

    const addShippingServiceRow = (index: number) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
        tempPreparedData.carrier_codes[index] = {
            ...tempPreparedData.carrier_codes[index],
            shipping_service: ""

        }
        setPreparedData({ ...tempPreparedData })

        let tempErrors = JSON.parse(JSON.stringify(errors));
        tempErrors.carrierCodes.push({ shopify: false, amazon: false })
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
    }



    const refundUpdateText = (type: string, value: any, index: number) => {
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (type == "shopify") {
            uiCarrierCode[index]['shopify_carrier_code'] = value;
        }
        else {
            uiCarrierCode[index]['amazon_carrier_code'] = value;
        }
        setUiCarrierCode([...uiCarrierCode]);
        if (!loading) {
            setLoading(true);
        }
        setTimeout(() => {
            if (value === '') {
                if (type == "shopify") {
                    setShopifyCarrierCodes([...(shopifyCarrierCodesFromBackend ?? deselectedShopifyCarrierCodes)]);
                }
                else {
                    setAmazonCarrierCodes([...(amazonCarrierCodesFromBackend ?? deselectedAmazonCarrierCodes)]);
                    tempErrors.carrierCodes[index]['amazon'] = value === '';
                }
                setErrors(JSON.parse(JSON.stringify(tempErrors)));
                setLoading(false);
                return;
            }
            const filterRegex = new RegExp(value, 'i');
            let resultOptions = [];
            if (type == "shopify") {
                resultOptions = shopifyCarrierCodes.filter((option: any) =>
                    option.label.match(filterRegex),
                );
                setShopifyCarrierCodes(resultOptions);
            }
            else {
                resultOptions = amazonCarrierCodes.filter((option) =>
                    option.label.match(filterRegex),
                );
                setAmazonCarrierCodes(resultOptions);
            }
            setLoading(false);
        }, 300);
    }

    const refundTextField = (type: string, index: number) => {
        let inputValue = '';
        let placeholder = '';
        if (type == "shopify") {
            inputValue = uiCarrierCode?.[index]?.['shopify_carrier_code'];
            placeholder = t("Search or type shopify carrier code")
        }
        else {
            inputValue = uiCarrierCode?.[index]?.['amazon_carrier_code'];
            placeholder = t("Search or type amazon carrier code")
        }
        return <Autocomplete.TextField
            onChange={(e: any) => refundUpdateText(type, e, index)}
            value={inputValue}
            prefix={<div><Icon source={SearchMinor} /></div>}
            placeholder={placeholder}
            label=""
            autoComplete='off'
        />;
    }




    const newCodesMarkUp = uiCarrierCode.map((obj: any, index: number) => {
        return (
            <ModalForShippingService t={t} key={index} refundTextField={refundTextField} loading={loading} setignoreShopifyCarrierCodes={setignoreShopifyCarrierCodes} updateSelection={updateSelection} setPreparedData={setPreparedData} setErrors={setErrors} errors={errors} ignoreShopifyCarrierCodes={ignoreShopifyCarrierCodes} amazonCarrierCodes={amazonCarrierCodes} shopifyCarrierCodes={shopifyCarrierCodes} setUiCarrierCode={setUiCarrierCode} uiCarrierCode={uiCarrierCode} preparedData={preparedData} obj={obj} error={errors?.carrierCodes?.[index]?.["shipping_service"]} addShippingServiceRow={addShippingServiceRow} index={index} ></ModalForShippingService>
        );
    })

    const validator = () => {
        let hasError = false;
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (preparedData.order_sync) {

            if (preparedData.shipment && preparedData.shipping_carrier_map) {
                preparedData.carrier_codes.forEach((obj: any, index: number) => {

                    if (obj['shopify_carrier_code'] == '' || obj['shopify_carrier_code'].trim().length == 0) {
                        hasError = true;
                        tempErrors.carrierCodes[index]['shopify'] = obj['shopify_carrier_code'] == '' || obj['shopify_carrier_code'].trim().length == 0
                    }
                    if (obj['amazon_carrier_code'] == '' || obj['amazon_carrier_code'].trim().length == 0) {
                        hasError = true;
                        tempErrors.carrierCodes[index]['amazon'] = obj['amazon_carrier_code'] == '' || obj['amazon_carrier_code'].trim().length == 0
                    }
                    if (obj['shipping_service'] == '' || obj['shipping_service']?.trim()?.length == 0) {
                        hasError = true;
                        tempErrors.carrierCodes[index]['shipping_service'] = obj['shipping_service'] == '' || obj['shipping_service'].trim().length == 0
                    }
                    if (obj['amazon_carrier_code'] == 'Other') {
                        if (preparedData?.['carrier_codes']?.[index]?.['carrier_name']?.length == 0) {
                            hasError = true;
                            tempErrors.carrierCodes = {
                                ...tempErrors.carrierCodes,
                                [index]: {
                                    amazon: true
                                }
                            }
                        }
                    }
                })
            }
        }
        return { hasError, tempErrors };
    }

    function filterEditedData(original: any, changed: any) {
        const allSettings = Object.keys(defaultOrderSettings);

        const myObj: any = {};
        allSettings.forEach((setting: string) => {
            if (JSON.stringify(changed[setting]) != JSON.stringify(original[setting])) {
                myObj[setting] = changed[setting];
            }
        });
        return myObj;
    }
    const prepareCustomData = () => {
        let prepare_data: any = []
        // let tempPreparedData: any = removeStaleValues(JSON.parse(JSON.stringify(preparedData)));
        // tempPreparedData?.carrier_name && Object.keys(tempPreparedData?.carrier_name).length > 0 && Object.keys(tempPreparedData?.carrier_name).map((key: any) => {
        //     prepare_data.push({
        //         "shopify_carrier_name": tempPreparedData?.carrier_codes?.[key]?.shopify_carrier_code,
        //         "amazon_carrier_name": tempPreparedData?.carrier_name?.[key]?.amazon_carrier_name
        //     })

        // })
        return prepare_data;



    }

    const prepareBackendData = () => {
        let tempPreparedData = removeStaleValues(JSON.parse(JSON.stringify(preparedData)));
        let editedData = filterEditedData(originalData, tempPreparedData);
        // let chkBackendDataCustom = prepareCustomData()

        // if (chkBackendDataCustom.length > 0) {
        //     editedData = {
        //         ...editedData,
        //         carrier_names: chkBackendDataCustom
        //     }
        // }
        // console.log(editedData, "kvvkkjvhkjhj");


        let backendData = [
            {
                data: JSON.parse(JSON.stringify(editedData)),
                group_code: "order"
            }
        ];

        setPreparedData({ ...tempPreparedData })
        return backendData;
    }

    const handleDiscardBtn = () => {
        setErrors(JSON.parse(JSON.stringify(defaultErrors)));
        setShowSkeleton(true);
        setShowContextualSaveBar(false);
        setPreparedData(JSON.parse(JSON.stringify(defaultOrderSettings)));
        setignoreShopifyCarrierCodes([]);
        getOrderSettings();
        getLastOrderSyncDate();
    }




    const handleSave = () => {
        setSaveLoader(true);
        const { hasError, tempErrors: receivedErrors } = validator();

        if (!hasError) {
            let backendData = prepareBackendData();
            props.di.POST('connector/config/saveConfig', {
                "data": backendData
            }).then((response: any) => {
                setShowContextualSaveBar(false);
                setSaveLoader(false);
                if (response?.success) {
                    props.success(t("Order settings saved successfully."));
                }
                else {
                    props.error(t(response?.message) ?? t("Oops! Some error occured while saving."));
                }
                getOrderSettings();
                getLastOrderSyncDate();
            })
        }
        else {
            props.error(t("Some information is missing or wrong, kindly check them before proceeding."));
            setSaveLoader(false);
            setErrors(JSON.parse(JSON.stringify(receivedErrors)));
        }
    }

    //Contextual Save Bar of App Bridge
    if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
        let savebar_options: any = {
            loading: saveLoader,
        };
        if (showContextualSaveBar) {
            showSaveBar(handleDiscardBtn, handleSave, { ...savebar_options });
        } else hideSaveBar();
    }

    // To remove Errors while resetting indivisually
    const removeErrors = (key: string) => {
        let tempErrors = JSON.parse(JSON.stringify(errors))
        if (key === "") {
            if (tempErrors?.customTag) {
                tempErrors.customTag = false;
            }
        }
        else {
            tempErrors?.[key]?.map((obj: any) => {
                if (obj.amazon || obj.shopify) {
                    obj.amazon = false;
                    obj.shopify = false;
                }
            });
        }
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
    }

    return (
        showSkeleton ? RenderSkeletonShipment() :
            <>
                {showContextualSaveBar && (process.env.REACT_APP_PROD === "0" ||
                    isAdminLoggedIn()) && (
                        <ContextualSaveBar
                            message={t("Unsaved changes")}
                            saveAction={{
                                onAction: () => handleSave(),
                                loading: saveLoader,
                                disabled: false,
                            }}
                            discardAction={{
                                onAction: () => { handleDiscardBtn() },
                            }}
                        />
                    )}
                <BlockStack gap="500">
                    <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }} >
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }} >
                            <BlockStack gap="200">
                                <Text variant="headingMd" as="h6" id='shipment_Text_ShipmentSettings'>
                                    {t("Shipment Settings")}
                                </ Text>
                                <Text as="p" fontWeight="regular" id='shipment_Text_ShipmentSettingsDescription'>
                                    {t("Synchronize shipping status updates from Shopify to Amazon.")}
                                </Text>
                            </BlockStack>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                            <div className='Custom__Button--Alignment'>
                                <ButtonGroup variant='segmented'>
                                    <Button id="shipment_Btn_Enable" disabled={saveLoader} pressed={preparedData.shipment} onClick={() => { handleSettingsEnableOrDisable(true) }}>{t("Enable")}</Button>
                                    <Button id="shipment_Btn_Disable" disabled={saveLoader} pressed={!preparedData.shipment} onClick={() => { handleSettingsEnableOrDisable(false) }}>{t("Disable")}</Button>
                                </ButtonGroup>
                            </div>
                        </Grid.Cell>
                    </Grid>
                    <Divider borderColor='border-secondary' />
                    <BlockStack gap="500">
                        <BlockStack gap={'200'}>
                            <InlineStack gap="400" blockAlign='center'>
                                <div className='Custom__Line--Height'>
                                    <Text variant="headingSm" as="h6" id='shipment_Text_TrackingDetails'>
                                        Tracking Details
                                    </Text>
                                </div>
                                <Badge tone='info'>Recommended</Badge>
                            </InlineStack>
                            <BlockStack gap="200">
                                <Text as="p" fontWeight="regular" tone='subdued' id='shipment_Text_TrackingDetailsDescription'>
                                    By enabling these settings, you ensure that only orders with valid tracking information are synced to Amazon.
                                </Text>
                                <Banner tone="warning" hideIcon>
                                    <InlineStack gap={'200'} blockAlign="start" wrap={false}>
                                        <Badge tone='attention'>Note</Badge>
                                        <Text as='p'>
                                            Amazon strongly recommends shipping orders with accurate tracking details to enhance customer satisfaction. Additionally, failing to provide valid tracking information can negatively impact your Valid Tracking Rate (VTR) Score, a critical seller metric. <Link target='_blank' url='https://www.youtube.com/watch?v=aEi_IUPoCDg'>Learn more about the VTR score here.</Link>
                                        </Text>
                                    </InlineStack>
                                </Banner>
                            </BlockStack>
                        </BlockStack>
                        <BlockStack gap="300">
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='shipment_Switch_Tracking_Company' size='small' onChange={(e: boolean) => handleData("tracking_company", "", e)} checked={preparedData.tracking_company} disabled={!preparedData.shipment} />
                                <BlockStack gap="100">
                                    <InlineStack gap="400" blockAlign='center'>
                                        <div className='Custom__Line--Height'>
                                            <Text variant="headingSm" as="h6" id='shipment_Text_TrackingDetails'>
                                                {t("Tracking Company")}
                                            </Text>
                                        </div>
                                    </InlineStack>
                                    <div>
                                        <Text as="p" fontWeight="regular" tone='subdued' id='shipment_Text_TrackingDetailsDescription'>
                                            {t("Enable this setting to sync tracking details only when a tracking company is provided by Shopify.")}
                                        </Text>
                                    </div>
                                </BlockStack>
                            </InlineStack>

                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='shipment_Switch_Tracking_Number' size='small' onChange={(e: boolean) => handleData("tracking_number", "", e)} checked={preparedData.tracking_number} disabled={!preparedData.shipment} />
                                <BlockStack gap="100">
                                    <InlineStack gap="400" blockAlign='center'>
                                        <div className='Custom__Line--Height'>
                                            <Text variant="headingSm" as="h6" id='shipment_Text_TrackingDetails'>
                                                {t("Tracking Number")}
                                            </Text>
                                        </div>
                                    </InlineStack>
                                    <div>
                                        <Text as="p" fontWeight="regular" tone='subdued' id='shipment_Text_TrackingDetailsDescription'>
                                            {t("Enable this setting to sync tracking details only when a tracking number is provided by Shopify.")}
                                        </Text>
                                    </div>
                                </BlockStack>
                            </InlineStack>
                            <Divider borderColor='border-secondary' />

                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='shipment_Switch_CarrierCodes' size='small' onChange={(e: boolean) => {
                                    if (!e) { removeErrors('carrierCodes'); }
                                    handleData("shipping_carrier_map", "", e)
                                }}
                                    checked={preparedData.shipping_carrier_map}
                                    disabled={!preparedData.shipment} />
                                <div className='Custom__Flex--Set'>
                                    <BlockStack gap="300">
                                        <BlockStack gap="100">
                                            <div className='Custom__Line--Height'>
                                                <Text variant="headingSm" as="h6" id='shipment_Text_CarrierCodes'>
                                                    {t("Map Carrier Codes")}
                                                </Text>
                                            </div>
                                            <Text as='p' fontWeight="regular" tone='subdued' id='shipment_Text_CarrierCodesDescription'>{t("This is the carrier value as defined by Amazon and Shopify. Map them to ensure error-free order fulfillment")}</Text>
                                            <Text as="p" fontWeight="regular" tone='subdued' id='shipment_Text_CarrierCodesDescription'>
                                                {t("For example, the carrier code on Shopify is 4PX Express. However, Amazon is only considering 4PX as the carrier code. Now, if you select 4PX Express as the carrier code on Shopify, Amazon will mark an error stating: Invalid Tracking Detail. So for Amazon orders, to avoid a situation where the order is considered to have invalid Tracking details, map Shopify carrier codes: 4PX Express with Amazon carrier code: 4PX only.")}
                                            </Text>
                                        </BlockStack>
                                        {newCodesMarkUp}
                                        <div style={{ marginTop: "4px" }}>
                                            <Button id='shipment_Btn_AddNewCarrierCode' icon={PlusMinor} onClick={addCarrierCodeRow} disabled={!preparedData.shipment || !preparedData.shipping_carrier_map || (preparedData?.carrier_codes[preparedData?.carrier_codes?.length - 1]?.amazon_carrier_code.length == 0 || preparedData?.carrier_codes[preparedData?.carrier_codes?.length - 1]?.shopify_carrier_code.length == 0)}>{t("Add New Carrier Code")}</Button>
                                        </div>
                                    </BlockStack >
                                </div >
                            </InlineStack >
                        </BlockStack>
                    </BlockStack>


                    {lastSync && <>
                        <Divider borderColor='border-secondary' />
                        <InlineStack blockAlign='center' align='space-between' gap="200">
                            <div className='Custom__Sync--Update'>
                                <InlineStack gap="200" wrap={false}>
                                    <div>
                                        <Icon source={RefreshMajor} tone="base" />
                                    </div>
                                    <Text variant="headingSm" as="h6" tone='subdued'>
                                        {t("Last updated")}: {lastSync}
                                    </Text>
                                </InlineStack>
                            </div >
                        </InlineStack >
                    </>}
                </BlockStack >
            </>
    );
};

const ModalForShippingService = ({ refundTextField, loading, t, setignoreShopifyCarrierCodes, updateSelection, setPreparedData, setErrors, errors, ignoreShopifyCarrierCodes, amazonCarrierCodes, shopifyCarrierCodes, setUiCarrierCode, uiCarrierCode, preparedData, obj, error, index }: any) => {
    const [visibility, setvisibility] = useState<boolean>(false)
    const [inputValue, setInputValue] = useState<string>(preparedData?.['carrier_codes']?.[index]?.shipping_service ?? "")
    useEffect(() => setInputValue(preparedData?.['carrier_codes']?.[index]?.shipping_service ?? ""), [preparedData])


    const handleChangeShippingService = useCallback((index: number) => {
        setvisibility(false)
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (inputValue.trim().length > 0) {
            tempPreparedData.carrier_codes[index]['shipping_service'] = inputValue
        }
        else {
            delete tempPreparedData.carrier_codes[index]['shipping_service']
        }
        // tempErrors['carrierCodes'][index]['shipping_service'] = value.trim().length > 0 ? false : true
        // setErrors(JSON.parse(JSON.stringify(tempErrors)));
        setPreparedData({ ...tempPreparedData })
    }, [preparedData, inputValue])


    const handleShippingInput = useCallback((value: string) => {
        setInputValue(value)
    }, [])



    const handleBtnClick = (index: number, type: string) => {
        if (type == "shopify") {
            uiCarrierCode[index]['activateShopify'] = !uiCarrierCode[index]['activateShopify']
            uiCarrierCode.forEach((_: any, idx: any) => {
                if (idx !== index)
                    uiCarrierCode[idx]['activateShopify'] = false;
                uiCarrierCode[idx]['activateAmazon'] = false
            })
        }
        else {
            uiCarrierCode[index]['activateAmazon'] = !uiCarrierCode[index]['activateAmazon']
            uiCarrierCode.forEach((_: any, idx: any) => {
                if (idx !== index)
                    uiCarrierCode[idx]['activateAmazon'] = false
                uiCarrierCode[idx]['activateShopify'] = false;
            })
        }
        setUiCarrierCode([...uiCarrierCode])
    }
    const deleteCarrierCodeRow = (index: number) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        if (uiCarrierCode.length > 1 && tempPreparedData.carrier_codes.length > 1) {

            let tempOptions = ignoreShopifyCarrierCodes.filter((option: any) => option != JSON.parse(JSON.stringify(preparedData))?.carrier_codes?.[index]?.shopify_carrier_code);
            setignoreShopifyCarrierCodes([...tempOptions]);

            tempPreparedData.carrier_codes.splice(index, 1);
            setPreparedData({ ...tempPreparedData });

            uiCarrierCode.splice(index, 1)
            setUiCarrierCode([...uiCarrierCode])

            let tempErrors = JSON.parse(JSON.stringify(errors));
            tempErrors.carrierCodes.splice(index, 1)
            setErrors(JSON.parse(JSON.stringify(tempErrors)));
        }
    }
    const deleteshippingService = (index: number) => {
        // Create a deep copy of preparedData
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData));

        // Ensure carrier_codes is an array and within bounds
        if (Array.isArray(tempPreparedData?.carrier_codes) && tempPreparedData.carrier_codes[index]) {
            delete tempPreparedData.carrier_codes[index].shipping_service;
        }
        // Update preparedData state
        setPreparedData({ ...tempPreparedData });

        // Create a deep copy of errors
        let tempErrors = JSON.parse(JSON.stringify(errors));

        // Remove the error at the specified index if carrierCodes is an array
        if (Array.isArray(tempErrors?.carrierCodes)) {
            delete tempErrors.carrierCodes[index].shipping_service;
        }
        // Update errors state
        setErrors({ ...tempErrors });
    };
    const handleTextFieldChange = (index: number, type: string, value: string, custom: string | boolean = false) => {
        let tempPreparedData = JSON.parse(JSON.stringify({ ...preparedData }));
        let tempErrors = JSON.parse(JSON.stringify({ ...errors }));
        if (type == "shopify") {
            tempPreparedData.carrier_codes[index]['shopify_carrier_code'] = value
            tempErrors['carrierCodes'][index]['shopify'] = value == ""
        }
        else {
            if (custom) {
                tempPreparedData.carrier_codes[index]['amazon_carrier_code'] = "Other"
                tempPreparedData.carrier_codes[index]['carrier_name'] = value
                tempErrors['carrierCodes'][index]['carrier_name'] = value == ""
                // tempPreparedData['carrier_name'] = {
                //     ...tempPreparedData['carrier_name'],
                //     [index]: {
                //         amazon_carrier_name: value,
                //         shopify_carrier_name: tempPreparedData?.carrier_codes?.[index]?.['shopify_carrier_code'] || ""

                //     }
                // }
                // tempErrors['carrier_name'] = {
                //     ...tempErrors['carrier_name'],
                //     [index]: {
                //         'amazon': value == ""
                //     }
                // }

            } else {
                tempPreparedData.carrier_codes[index]['amazon_carrier_code'] = value

                tempErrors['carrierCodes'][index]['amazon'] = value == ""
            }
        }
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
        setPreparedData({ ...tempPreparedData })
    }
    const [popoverActive, setPopoverActive] = useState(false);

    const togglePopoverActive = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        [],
    );

    const activator = (
        <Button disabled={!preparedData.shipment || !preparedData.shipping_carrier_map} onClick={togglePopoverActive} icon={MobileVerticalDotsMajor} />
    );

    return (
        <BlockStack key={index} gap="300">
            <InlineGrid gap={'400'} columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <Box>
                    <TextField
                        id={`shipment_TextField_CarrierCode_${obj?.shopify_carrier_code}_${index}`}
                        connectedLeft={
                            <InlineStack gap="500">
                                <Popover
                                    sectioned
                                    active={obj['activateShopify']}
                                    activator={<Tooltip content={t('Search Shopify Carrier Codes')}><Button id={`shipment_Btn_Shopify_${index}`} onClick={() => handleBtnClick(index, "shopify")} icon={SearchMinor} disabled={!preparedData.shipment || !preparedData.shipping_carrier_map} /></Tooltip>}
                                    onClose={obj['activateShopify'] ? () => { setTimeout(() => { handleBtnClick(index, "shopify") }, 0) } : () => { }}
                                >
                                    <Autocomplete
                                        id={`shipment_Autocomplete_CarrierCode_${obj?.shopify_carrier_code}_${index}`}
                                        options={shopifyCarrierCodes?.filter((option: any) => ignoreShopifyCarrierCodes.indexOf(option.value) == -1)}
                                        selected={obj['shopify_carrier_code']}
                                        onSelect={(e: any) => {
                                            updateSelection("shopify", e, index)
                                        }}
                                        loading={loading}
                                        textField={refundTextField("shopify", index)}
                                    />
                                </Popover>
                            </InlineStack>
                        }
                        placeholder={'Ex- Amazon Logistics'}
                        value={preparedData?.['carrier_codes']?.[index]?.['shopify_carrier_code']} label={t('Shopify carrier code')} onChange={(e) => { handleTextFieldChange(index, "shopify", e) }} autoComplete="off" disabled={obj['isShopifyDisabled'] || !preparedData.shipping_carrier_map} error={errors?.carrierCodes?.[index]?.['shopify']} />
                </Box>
                <Box>
                    <InlineStack blockAlign="end" gap={'400'} wrap={false}>
                        <TextField
                            id={`shipment_TextField_CarrierCode_${obj?.amazon_carrier_code}_${index}`}
                            connectedLeft={
                                <Popover
                                    sectioned
                                    active={obj['activateAmazon']}
                                    activator={
                                        <Tooltip content={t("Search Amazon Carrier Codes")}>
                                            <Button
                                                id={`shipment_Btn_Amazon_${index}`}
                                                onClick={() =>
                                                    handleBtnClick(
                                                        index,
                                                        'amazon'
                                                    )
                                                }
                                                icon={SearchMinor}
                                                disabled={
                                                    !preparedData.shipment ||
                                                    !preparedData.shipping_carrier_map
                                                }
                                            />
                                        </Tooltip>
                                    }
                                    onClose={
                                        obj['activateAmazon']
                                            ? () => {
                                                setTimeout(() => {
                                                    handleBtnClick(
                                                        index,
                                                        'amazon'
                                                    );
                                                }, 0);
                                            }
                                            : () => { }
                                    }>
                                    <Autocomplete
                                        id={`shipment_Autocomplete_CarrierCode_${obj?.amazon_carrier_code}_${index}`}
                                        options={amazonCarrierCodes}
                                        selected={obj['amazon_carrier_code']}
                                        onSelect={(e: any) =>
                                            updateSelection('amazon', e, index)
                                        }
                                        loading={loading}
                                        textField={refundTextField(
                                            'amazon',
                                            index
                                        )}
                                    />
                                </Popover>
                            }
                            placeholder={t('Eg- Amazon Shipping')}
                            value={
                                obj['isAmazonDisabled'] ? preparedData?.['carrier_codes']?.[index]?.[
                                    'amazon_carrier_code'
                                ] : "Other"
                            }
                            label={t("Amazon carrier code")}
                            onChange={(e) => {
                                handleTextFieldChange(index, 'amazon', e);
                            }}
                            autoComplete="off"
                            // disabled={
                            //     obj['isAmazonDisabled'] ||
                            //     !preparedData.shipping_carrier_map
                            // }
                            disabled
                            error={errors?.carrierCodes?.[index]?.['amazon']}
                        />
                        <Popover
                            active={popoverActive}
                            activator={activator}

                            onClose={togglePopoverActive}>
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    {
                                        content: !preparedData?.[
                                            'carrier_codes'
                                        ]?.[index]?.['shipping_service']
                                            ? t('Add shipment service')
                                            : t('Edit shipment service'),
                                        icon: !preparedData?.[
                                            'carrier_codes'
                                        ]?.[index]?.['shipping_service']
                                            ? AddMajor
                                            : EditMajor,
                                        onAction: () => {
                                            setvisibility(true);
                                        },
                                    },
                                    ...(uiCarrierCode.length > 1 ? [ // Add delete button conditionally
                                        {
                                            content: t('Delete'),
                                            icon: DeleteMinor,
                                            onAction: () => deleteCarrierCodeRow(index),
                                        },
                                    ] : [])

                                ]}
                            />
                        </Popover>
                    </InlineStack>
                    <div
                        className="custom-shopify-code__input"
                        style={{
                            marginTop: '8px',
                        }}>
                        {(
                            !obj['isAmazonDisabled']
                            || preparedData?.['carrier_codes']?.[index].hasOwnProperty("carrier_name")
                        ) && (
                                <InlineStack gap={"200"} wrap={false} align='space-between'>
                                    <TextField
                                        autoComplete="off"
                                        label=""
                                        labelHidden
                                        disabled={!preparedData.shipment || !preparedData.shipping_carrier_map}
                                        onChange={(e) => handleTextFieldChange(index, 'amazon', e, "custom")}
                                        value={
                                            preparedData?.['carrier_codes']?.[index]?.[
                                            'carrier_name'
                                            ]
                                        }
                                        error={errors?.carrierCodes?.[index]?.['amazon']}
                                        placeholder={t("Custom carrier name")}
                                    />
                                    <Tooltip content={t('It is a custom Carrier Name which is not listed on Amazon')}><Button disabled={!preparedData.shipment || !preparedData.shipping_carrier_map} icon={InfoMinor}></Button></Tooltip>
                                </InlineStack>
                            )}
                        {preparedData?.['carrier_codes']?.[index]?.['shipping_service'] &&
                            <div style={{ paddingTop: "10px" }}>
                                <InlineStack align='start' blockAlign='end' gap={'100'} wrap={false}>
                                    <Text tone={(!preparedData.shipment || !preparedData.shipping_carrier_map) ? "subdued" : undefined} as='strong'>{t("Shipping service:")}</Text>
                                    <Text tone='success' as='p'>{preparedData?.['carrier_codes']?.[index]?.['shipping_service']}</Text>
                                    <Button disabled={!preparedData.shipment || !preparedData.shipping_carrier_map} onClick={() => deleteshippingService(index)} variant='plain'>{t("Remove")}</Button>
                                </InlineStack>
                            </div>
                        }

                    </div>
                </Box>
            </InlineGrid>

            {((obj['isShopifyDisabled'] || !preparedData.shipping_carrier_map) && (preparedData?.['carrier_codes']?.[index]?.['shopify_carrier_code'] && !preparedData?.['carrier_codes']?.[index]?.['amazon_carrier_code'])) && <InlineStack>
                <Icon source={preparedData?.['carrier_codes']?.[index]?.['amazon_carrier_code'].length > 0 ? CircleTickMinor : CircleAlertMajor}></Icon>
                <Text as='p' tone={preparedData?.['carrier_codes']?.[index]?.['amazon_carrier_code'].length > 0 ? "success" : "critical"}>{preparedData?.['carrier_codes']?.[index]?.['amazon_carrier_code'].length > 0 ? t("Mapped carrier codes between shopify and Amazon") : t("Mapping of carrier codes is needed")}</Text>
            </InlineStack>}
            <Modal
                // activator={visi}
                open={visibility}
                size='small'
                onClose={() => { setvisibility(false); setInputValue(preparedData?.['carrier_codes']?.[index]?.shipping_service ?? "") }}
                title={t("Shipment service")}
                primaryAction={{
                    content: t('Done'),
                    onAction: () => handleChangeShippingService(index),
                }}
                secondaryActions={[
                    {
                        content: t('Close'),
                        onAction: () => { setvisibility(false); setInputValue(preparedData?.['carrier_codes']?.[index]?.shipping_service ?? "") },
                    },
                ]}
            >
                <Modal.Section>
                    <TextField error={error} label={undefined} placeholder={t('Add your shipping service')} autoComplete="off" value={inputValue} onChange={(e) => { handleShippingInput(e) }} />
                </Modal.Section>
            </Modal>
        </BlockStack>

    )

}
export default DI(Shipment);